"use client"

import { useState, useEffect } from "react"
import Link from "next/link"
import { Menu, X } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet"
import { usePathname } from "next/navigation"
import { ThemeToggle } from "@/components/theme-toggle"

const navItems = [
  { title: "Articles", href: "/articles" },
  // { title: "Wall of Love", href: "/wall-of-love" },
  { title: "About Us", href: "/about" },
  { title: "Contact", href: "/contact" },
]

export function MobileNav() {
  const [open, setOpen] = useState(false)
  const pathname = usePathname()
  const isLandingPage = pathname === "/"

  // Close sheet on path change
  useEffect(() => {
    setOpen(false)
  }, [pathname])

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="md:hidden">
          <Menu className="h-6 w-6" />
          <span className="sr-only">Toggle Menu</span>
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="w-full max-w-xs p-6 flex flex-col">
        <>
          <nav className="flex-grow space-y-2">
            {navItems.map((item) => (
            <Link
                key={item.title}
                href={isLandingPage && item.href.startsWith("/#") ? item.href : item.href.replace("/#", "/")}
                className="flex items-center rounded-lg px-3 py-2 text-base font-medium text-foreground hover:bg-accent hover:text-accent-foreground transition-colors"
              onClick={() => setOpen(false)}
            >
                {item.title}
            </Link>
            ))}
          </nav>
          <div className="mt-auto pt-6 border-t border-border/30 space-y-3">
            <Button variant="ghost" asChild className="w-full justify-center h-12 text-base">
              <Link href="/auth/sign-in" onClick={() => setOpen(false)}>Log In</Link>
            </Button>
            <Button asChild className="w-full justify-center h-12 text-base">
              <Link href="/signup" onClick={() => setOpen(false)}>Sign Up Free</Link>
            </Button>
            <div className="flex justify-center pt-4">
              <ThemeToggle />
            </div>
          </div>
        </>
      </SheetContent>
    </Sheet>
  )
}

